<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import MultiselectDropdown from '../../../../../shared/components/ui/MultiselectDropdown.vue';

const props = defineProps({
  priorities: {
    type: Array,
    default: () => [],
  },
  selectedPriorityId: {
    type: [Number, String],
    default: null,
  },
  updateHistory: {
    type: Boolean,
    default: false,
  },
  ticketId: {
    type: [Number, String],
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:selectedPriorityId', 'change']);

const store = useStore();

const selectedPriority = computed(() => {
  return (
    props.priorities.find(
      priority => priority.id === props.selectedPriorityId
    ) || {}
  );
});

const handlePriorityChange = async newPriority => {
  if (newPriority.id === props.selectedPriorityId) return;

  emit('update:selectedPriorityId', newPriority.id);
  emit('change', newPriority);

  // If updateHistory is true, update the ticket history
  if (props.updateHistory && props.ticketId) {
    try {
      const response = await store.dispatch('tickets/changePriority', {
        id: props.ticketId,
        newPriority: newPriority.id,
      });

      if (response && response.priority_name) {
        store.commit('tickets/UPDATE_TICKET_PRIORITY', {
          id: props.ticketId,
          priority_name: response.priority_name,
          priority_id: response.priority_id,
        });
      }

      // Reload ticket to ensure status label is updated after automatic status change
      await store.dispatch('tickets/getTicket', props.ticketId);
      // Refresh the ticket history immediately after the change
      await store.dispatch('tickets/getTicketHistory', props.ticketId);
    } catch (error) {
      console.error('Error updating priority:', error);
      // Revert the change on error
      emit('update:selectedPriorityId', props.selectedPriorityId);
    }
  }
};
</script>

<template>
  <div>
    <div @click.prevent>
      <MultiselectDropdown
        :options="priorities"
        :selected-item="selectedPriority"
        multiselector-title="Selecionar Prioridade"
        multiselector-placeholder="Selecionar Prioridade"
        input-placeholder="Buscar prioridade..."
        no-search-result="Nenhuma prioridade encontrada"
        :has-thumbnail="false"
        @select="handlePriorityChange"
      />
    </div>
  </div>
</template>
